import { render } from "./jiNoMakiPreface.vue?vue&type=template&id=77ab7132"
const script = {}

import "./jiNoMakiPreface.vue?vue&type=style&index=0&id=77ab7132&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__